import React from "react";
import { Box, Tooltip, Fab } from "@mui/material";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import CallIcon from "@mui/icons-material/Call";

export default function ContactFloat({ page = "home" }) {
  /* ================= CONFIG ================= */
  const phoneNumber = "919955182103"; // WhatsApp + Call number

  // ⏰ Business Hours (8 AM – 8 PM)
  const currentHour = new Date().getHours();
  const isBusinessHours = currentHour >= 8 && currentHour < 20;

  // ❌ Auto-hide outside business hours
  if (!isBusinessHours) return null;

  // 📩 Page-wise predefined messages
  const messages = {
    home: "Hello Maa Sharde Digital Seva Kendra, I need general information.",
    contact: "Hello, I want to contact Maa Sharde Digital Seva Kendra.",
    jobs: "Hello, I need information about Sarkari Jobs.",
    admit: "Hello, I need help regarding Admit Card.",
    default: "Hello Maa Sharde Digital Seva Kendra."
  };

  const message = encodeURIComponent(messages[page] || messages.default);

  return (
    <Box
      sx={{
        position: "fixed",
        bottom: { xs: 16, md: 24 },
        right: { xs: 16, md: 24 },
        display: "flex",
        flexDirection: "column",
        gap: 1.5,
        zIndex: 9999
      }}
    >
      {/* 📞 CALL BUTTON */}
      <Tooltip title="Call us" placement="left">
        <Fab
          color="primary"
          size="medium"
          component="a"
          href={`tel:+${phoneNumber}`}
          sx={{
            background: "#0b5ed7",
            "&:hover": { background: "#084298" }
          }}
        >
          <CallIcon />
        </Fab>
      </Tooltip>

      {/* 💬 WHATSAPP BUTTON */}
      <Tooltip title="Chat with us" placement="left">
        <Fab
          size="medium"
          component="a"
          href={`https://wa.me/${phoneNumber}?text=${message}`}
          target="_blank"
          sx={{
            background: "#25D366",
            color: "#fff",
            "&:hover": { background: "#1ebe57" },
            animation: "pulse 1.6s infinite"
          }}
        >
          <WhatsAppIcon />
        </Fab>
      </Tooltip>

      {/* 🔁 Pulse Animation */}
      <style>
        {`
          @keyframes pulse {
            0% {
              box-shadow: 0 0 0 0 rgba(37, 211, 102, 0.6);
            }
            70% {
              box-shadow: 0 0 0 14px rgba(37, 211, 102, 0);
            }
            100% {
              box-shadow: 0 0 0 0 rgba(37, 211, 102, 0);
            }
          }
        `}
      </style>
    </Box>
  );
}
